export const FETCH_GROUP_SUMMARIES = 'FETCH_GROUP_SUMMARIES';
export const FETCH_GROUP_SUMMARIES_SUCCESS = 'FETCH_GROUP_SUMMARIES_SUCCESS';
export const FETCH_GROUP_SUMMARIES_ERROR = 'FETCH_GROUP_SUMMARIES_ERROR';

export const fetchGroupSummaries = () => ({ type: FETCH_GROUP_SUMMARIES });

export const IMPORT_API = 'IMPORT_API';
export const IMPORT_API_CANCEL = 'IMPORT_API_CANCEL';

export const importApi = (type) => ({
	type: IMPORT_API, payload: type
});

export const importApiCancel = () => ({
	type: IMPORT_API_CANCEL, payload: {}
});

export const VALIDATE_SWAGGER = 'VALIDATE_SWAGGER';
export const VALIDATE_SWAGGER_SUCCESS = 'VALIDATE_SWAGGER_SUCCESS';
export const VALIDATE_SWAGGER_ERROR = 'VALIDATE_SWAGGER_ERROR';

export const validateSwagger = (fileOrUrl, type) => ({
	type: VALIDATE_SWAGGER, payload: { fileOrUrl, type }
});

export const SAVE_ENDPOINT = 'SAVE_ENDPOINT';
export const SAVE_ENDPOINT_SUCCESS = 'SAVE_ENDPOINT_SUCCESS';
export const SAVE_ENDPOINT_ERROR = 'SAVE_ENDPOINT_ERROR';

export const saveEndpoint = (importOptions) => ({
	type: SAVE_ENDPOINT, payload: importOptions
});

export const FETCH_ENDPOINT = 'FETCH_ENDPOINT';
export const FETCH_ENDPOINT_SUCCESS = 'FETCH_ENDPOINT_SUCCESS';
export const FETCH_ENDPOINT_ERROR = 'FETCH_ENDPOINT_ERROR';
export const fetchEndpoint = (endpointId) => ({
	type: FETCH_ENDPOINT, payload: { endpointId }
});

export const DELETE_ENDPOINT_CONFIRM = 'DELETE_ENDPOINT_CONFIRM';
export const DELETE_ENDPOINT = 'DELETE_ENDPOINT';
export const DELETE_ENDPOINT_ERROR = 'DELETE_ENDPOINT_ERROR';
export const DELETE_ENDPOINT_SUCCESS = 'DELETE_ENDPOINT_SUCCESS';
export const confirmDeleteEndpoint = (payload) => ({
	type: DELETE_ENDPOINT_CONFIRM,
	payload });
export const deleteEndpoint = (payload) => ({ type: DELETE_ENDPOINT, payload });

export const TEST_API_ENDPOINT = 'TEST_API_ENDPOINT';
export const TEST_API_ENDPOINT_SUCCESS = 'TEST_API_ENDPOINT_SUCCESS';
export const TEST_API_ENDPOINT_ERROR = 'TEST_API_ENDPOINT_ERROR';
export const TEST_API_ENDPOINT_CANCEL = 'TEST_API_ENDPOINT_CANCEL';
export const TEST_API_ENDPOINT_CLEAR = 'TEST_API_ENDPOINT_CLEAR';

export const testAPIEndpoint = (endpointId, methodId, request) => ({
	type: TEST_API_ENDPOINT, payload: { endpointId, methodId, request }
});

export const testAPIEndpointClear = (endpointId, methodId) => ({
	type: TEST_API_ENDPOINT_CLEAR, payload: { endpointId, methodId }
});

export const testAPIEndpointCancel = (endpointId, methodId) => ({
	type: TEST_API_ENDPOINT_CANCEL, payload: { endpointId, methodId }
});

export const FETCH_API_SPEC_TYPES = 'FETCH_API_SPEC_TYPES';
export const FETCH_API_SPEC_TYPES_SUCCESS = 'FETCH_API_SPEC_TYPES_SUCCESS';
export const FETCH_API_SPEC_TYPES_ERROR = 'FETCH_API_SPEC_TYPES_ERROR';

export const fetchApiSpecTypes = () => ({
	type: FETCH_API_SPEC_TYPES
});

export const DELETE_SPEC = 'DELETE_SPEC';
export const DELETE_SPEC_ERROR = 'DELETE_SPEC_ERROR';
export const deleteSpec = (type) => ({
	type: DELETE_SPEC, payload: { type }
});

export const DELETE_SPEC_COMPLETE = 'DELETE_SPEC_COMPLETE';
export const completeDeleteSpec = () => ({
	type: DELETE_SPEC_COMPLETE
});
